import { render, staticRenderFns } from "./design_details.vue?vue&type=template&id=468923c1"
import script from "./design_details.vue?vue&type=script&lang=js"
export * from "./design_details.vue?vue&type=script&lang=js"
import style0 from "./design_details.vue?vue&type=style&index=0&id=468923c1&prod&lang=css"
import style1 from "./design_details.vue?vue&type=style&index=1&id=468923c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports